import { Grid, Title as TitleBase, Paragraph } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import { withTracker } from '@/tracker';
import getMarkdownPaths from '@/ssr-props-getters/get-markdown-paths';
import getMarkdownContent from '@/ssr-props-getters/get-markdown-content';
import NotFullColumn from '@/components/not-full-column';
import SEO from '@/components/seo';
import MaxWidth from '@/components/max-width';

const Container = tw(MaxWidth)`
  pt-8
`;

const Title = tw(TitleBase)`
  text-brand-primary
  font-inter
  mt-0
`;

const Date = tw(Paragraph)`
  text-sm
  text-gray-500
  mb-8
`;

const Content = tw.div`
  prose
  lg:prose-xl
`;

const Post = ({ author, content, date, description, keywords, title }) => {
  return (
    <Container>
      <SEO title={title} description={description} keywords={keywords} />
      <Grid columns={12}>
        <NotFullColumn>
          <Title>{title}</Title>
          <Date>Posted by {author.name} on {date}</Date>
          <Content dangerouslySetInnerHTML={{ __html: content }} />
        </NotFullColumn>
      </Grid>
    </Container>
  );
};

export default withTracker(Post);

export async function getStaticPaths () {
  return getMarkdownPaths('posts');
}

export async function getStaticProps (context) {
  return getMarkdownContent(context, 'posts');
}
